import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const LinkIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 21 16.33",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 16.33),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m7.9 13.9-.8.8a3.86 3.86 0 1 1-5.47-5.46l4.1-4.1a3.86 3.86 0 0 1 5.86 5"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.26 2.27.64-.64a3.86 3.86 0 0 1 5.47 5.47l-4.1 4.1a3.86 3.86 0 0 1-5.86-5"
    })]
  });
};

export { LinkIcon };
//# sourceMappingURL=link.js.map
